import debug from 'debug';

const log = debug('FrontPageCatalogs:Data:Setting');

class Settings {
	static customerType;
	static showFeedCatalogs = false;
}

export default Settings;
